/**
 * Category Carousel with GSAP Background Effect
 * Carrossel com efeito de background dinâmico
 */

document.addEventListener('DOMContentLoaded', () => {
	const carousel = document.querySelector('[data-carousel-background]');
	if (!carousel) return;

	const carouselTrack = carousel.querySelector('[data-carousel-track]');
	if (!carouselTrack) return;

	const slides = carousel.querySelectorAll('[data-carousel-slide]');
	const backgroundImg = carousel.querySelector('[data-carousel-background-img]');
	const backgroundOverlay = carousel.querySelector('[data-carousel-background-overlay]');
	
	if (!slides.length || !backgroundImg) return;

	let currentIndex = 0;
	let autoplayTimeout;
	const AUTOPLAY_INTERVAL = 5000; // 5 segundos

	// Set initial background
	const firstSlideImg = slides[0].querySelector('img');
	if (firstSlideImg) {
		updateBackground(firstSlideImg.src);
	}

	// Handle slide click
	slides.forEach((slide, index) => {
		slide.addEventListener('click', () => {
			currentIndex = index;
			updateCarousel();
			resetAutoplay();
		});
	});

	// Navigation buttons
	const prevBtn = carousel.querySelector('[data-carousel-prev]');
	const nextBtn = carousel.querySelector('[data-carousel-next]');

	if (prevBtn) {
		prevBtn.addEventListener('click', () => {
			currentIndex = (currentIndex - 1 + slides.length) % slides.length;
			updateCarousel();
			resetAutoplay();
		});
	}

	if (nextBtn) {
		nextBtn.addEventListener('click', () => {
			currentIndex = (currentIndex + 1) % slides.length;
			updateCarousel();
			resetAutoplay();
		});
	}

	function updateCarousel() {
		// Update slide position
		gsap.to(carouselTrack, {
			x: -currentIndex * 100,
			duration: 0.6,
			ease: 'power2.inOut'
		});

		// Update background image with cover effect
		const activeSlideImg = slides[currentIndex].querySelector('img');
		if (activeSlideImg) {
			updateBackground(activeSlideImg.src);
		}

		// Update active indicator
		slides.forEach((slide, index) => {
			if (index === currentIndex) {
				slide.classList.add('active');
				gsap.to(slide, {
					scale: 1.05,
					duration: 0.3
				});
			} else {
				slide.classList.remove('active');
				gsap.to(slide, {
					scale: 1,
					duration: 0.3
				});
			}
		});
	}

	function updateBackground(imageSrc) {
		// Fade out overlay
		gsap.to(backgroundOverlay, {
			opacity: 1,
			duration: 0.3,
			ease: 'power2.inOut'
		});

		// Change background image
		gsap.to(backgroundImg, {
			opacity: 0,
			duration: 0.3,
			onComplete: () => {
				backgroundImg.style.backgroundImage = `url(${imageSrc})`;
				gsap.to(backgroundImg, {
					opacity: 1,
					duration: 0.4,
					ease: 'power2.inOut'
				});

				// Fade out overlay
				gsap.to(backgroundOverlay, {
					opacity: 0.3,
					duration: 0.5,
					delay: 0.2,
					ease: 'power2.inOut'
				});
			}
		});

		// Zoom effect on background image
		gsap.fromTo(
			backgroundImg,
			{ scale: 1.05 },
			{
				scale: 1,
				duration: 8,
				ease: 'power1.inOut',
				overwrite: false
			}
		);
	}

	function resetAutoplay() {
		clearTimeout(autoplayTimeout);
		startAutoplay();
	}

	function startAutoplay() {
		autoplayTimeout = setTimeout(() => {
			currentIndex = (currentIndex + 1) % slides.length;
			updateCarousel();
		}, AUTOPLAY_INTERVAL);
	}

	// Start autoplay
	startAutoplay();

	// Pause autoplay on hover
	carousel.addEventListener('mouseenter', () => {
		clearTimeout(autoplayTimeout);
	});

	carousel.addEventListener('mouseleave', () => {
		startAutoplay();
	});
});
